export enum PointsSource {
    GEMZ = 'gemz',
    DEFORM = 'deform',
}

export enum PointsActivityType {
    CHECK_IN = 'CHECK_IN',
    REFERRAL = 'REFERRAL',
    TWEET_LIKE = 'TWEET_LIKE',
    TWEET_RETWEET = 'TWEET_RETWEET',
    TWEET_REPLY = 'TWEET_REPLY',
    TWEET_QUOTE = 'TWEET_QUOTE',
    TWITTER_FOLLOW = 'TWITTER_FOLLOW',
    DISCORD_JOIN = 'DISCORD_JOIN',
    EXTERNAL_LINK = 'EXTERNAL_LINK',
    NATIVE_TOKEN_OWNERSHIP = 'NATIVE_TOKEN_OWNERSHIP',
    FT_OWNERSHIP = 'FT_OWNERSHIP',
    NFT_OWNERSHIP = 'NFT_OWNERSHIP',
    SECRET_CODE = 'SECRET_CODE',
    FORM = 'FORM',
    OPEN_EDITION_NFT_MINT = 'OPEN_EDITION_NFT_MINT',
    G_GAME_WIN = 'G_GAME_WIN',
    G_GAME_PUBLISH = 'G_GAME_PUBLISH',
    G_HELP_FRIENDS = 'G_HELP_FRIENDS',
    G_PORTFOLIO_VALUE_ETH = 'G_PORTFOLIO_VALUE_ETH',
    G_PORTFOLIO_VALUE_GROWTH_ETH = 'G_PORTFOLIO_VALUE_GROWTH_ETH',
    G_HOLDING_COUNT_ETH = 'G_HOLDING_COUNT_ETH',
    G_HOLDING_COUNT_GROWTH_ETH = 'G_HOLDING_COUNT_GROWTH_ETH',
    G_HOLDING_COUNT_COINS = 'G_HOLDING_COUNT_COINS',
    G_HOLDING_COUNT_GROWTH_COINS = 'G_HOLDING_COUNT_GROWTH_COINS',
    G_HOLDERS_COUNT = 'G_HOLDERS_COUNT',
    G_HOLDERS_COUNT_GROWTH = 'G_HOLDERS_COUNT_GROWTH',
    G_FOLLOWERS_COUNT = 'G_FOLLOWERS_COUNT',
    G_FOLLOWERS_COUNT_GROWTH = 'G_FOLLOWERS_COUNT_GROWTH',
    G_HELPS_COUNT = 'G_HELPS_COUNT',
}

export enum CampaignSpotRecordStatus {
    ACTIVITY_PENDING = 'ACTIVITY_PENDING',
    ACTIVITY_SUCCEEDED = 'ACTIVITY_SUCCEEDED',
    ACTIVITY_FAILED = 'ACTIVITY_FAILED',
    REWARD_PENDING = 'REWARD_PENDING',
    COMPLETED = 'COMPLETED',
}

export interface PointsLogSchema {
    user_id: number;
    spot_id?: number;
    campaign_id: number;
    activity: string;
    points_source: PointsSource;
    points: number;
    game_id?: number;
    tx_hash: string;
}

export interface PointsActivity {
    activity_id: string;
    title?: string;
    description?: string;
    type: PointsActivityType;
    recurring_period_type?: string;
    recurring_period_count?: number;
    recurring_max_count?: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    properties?: any;
    start_date_time_at?: Date;
    end_date_time_at?: Date;
    created_at: Date;
    updated_at: Date;
    source: PointsSource;
}

export interface PointsCampaignSpot {
    id?: string;
    user_id?: number;
    points: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    linked_accounts?: any[];
    referral_code?: string;
    created_at?: Date;
}

export interface PointsActivityRecord {
    activity_record_id: string;
    tx_hash: string;
    spot_id?: string;
    user_id?: number;
    offchain_game_id?: number;
    status: CampaignSpotRecordStatus;
    activity_id: string;
    activity_type: PointsActivityType;
    title_override?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    properties?: any;
    points: number;
    error?: string;
    created_at?: Date;
    updated_at?: Date;
}
